import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UILink from 'UIComponents/link/UILink';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SkippedEnrollmentsEmptyState = ({
  openTroubleshootEnrollmentPanel
}) => {
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    direction: "column",
    padding: "1000",
    textAlign: "center",
    borderBlockStartWidth: "100",
    borderBlockStartStyle: "solid",
    borderBlockStartColor: "border-primary-default",
    children: [/*#__PURE__*/_jsx(UIIllustration, {
      name: "empty-state-charts",
      width: "40%",
      className: "m-y-6"
    }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "automation.enrollmentHistory.panel.skipped-enrollments.table.emptyState_jsx",
      elements: {
        Link: ({
          children
        }) => /*#__PURE__*/_jsx(UILink, {
          onClick: () => {
            openTroubleshootEnrollmentPanel();
          },
          children: children
        }),
        br: () => /*#__PURE__*/_jsx("br", {})
      }
    })]
  });
};
export default SkippedEnrollmentsEmptyState;